<template>
<div class="container-base"
     v-once>
  <div class="pages page-static">
    <div class="page-static-inner">
      <h1>利用規約</h1>
      <h2>第1条（規約の適用）</h2>
      <p>「{{ $site.name }}利用規約」（以下、「本規約」といいます）は、株式会社Yagish（以下、「当社」といいます。）が提供する本サービス（第2条で定義されます。）の利用者（以下、「サービス利用者」といいます。）および本サービスの会員として当社に登録されるサービス利用者（以下、「会員」といいます。）が本サービスを利用するにあたり行う一切の行為に適用されるものとし、サービス利用者は本規約に同意の上、本サービスを利用するものとします。</p>
      <h2>第2条（サービスの定義）</h2>
      <p>本サービスは、サービス利用者が入力した内容をPDFファイルとして出力するサービスであり、主として、以下の機能から構成されています。</p>
      <ol>
        <li>サービス利用者が入力した情報をPDFファイルに出力する機能</li>
        <li>会員が自身のメールアドレスにPDFファイルを送信する機能</li>
        <li>会員の行った編集履歴をサーバーに保存し、会員自身が任意で過去の編集履歴を復元できる機能</li>
      </ol>
      <h2>第3条（サービスの利用）</h2>
      <ol>
        <li>本サービスをご利用になる場合、サービス利用者は、本規約に同意する必要があります。 インターネットに接続の上、本サービスが提供されるウェブページにアクセスしていただく必要があります。本サービスを利用するためには、以下の環境が必要です。
          <ul>
            <li>日本語が利用可能であること</li>
            <li>CookieとJavaScriptの利用が可能であること</li>
            <li>その他当社の指定する環境であること</li>
          </ul>
        </li>
        <li>サービス利用者は自らの責任と費用において、本サービスへアクセス可能な機器、ソフト、環境を準備した上で本サービスを利用するものとします。会員は、当社によって提供されているインターフェイス以外の手段を用いて本サービスにアクセスしてはならないものとします。</li>
      </ol>
      <h2>第4条（{{ $site.name }}利用規約の範囲）</h2>
      <ol>
        <li>本規約以外に、当社が別途次の各号の事項（以下、「{{ $site.name }}利用に関する告知事項」といいます。）を定めた場合には、これらも本規約と同等の効力を有し、本サービスの利用に関し、適用されるものとします。
          <ul>
            <li>「ご利用上の注意」、「ご案内」等、名称の如何を問わず、{{ $site.name }}の利用方法に関して{{ $site.name }}のウェブサイト上で告知される利用上の注意事項</li>
            <li>前号の他、会員の資格、権利、{{ $site.name }}の利用、その他必要事項に関し、{{ $site.name }}のウェブサイト上の表示として随時なされる通知</li>
          </ul>
        </li>
        <li>前項の{{ $site.name }}利用に関する告知事項は、特に適用開始時期を定めない限り、当社が当該{{ $site.name }}利用に関する告知事項をサイト上に表示したときをもって効力を生じ、同時に会員の承諾があったものとみなします。（以下、単に本規約という場合には、「{{ $site.name }}利用に関する告知事項」を含むものとします。）</li>
      </ol>
      <h2>第5条（サービスの中断・中止等）</h2>
      <p>当社は、当社の自由裁量により会員への事前の通知及び承諾を得ることなく、本サービスの一部または全部を中断、中止、停止、廃止、変更することができます。なお、本サービスの中断、中止、停止、廃止、変更により会員に生じた損害について、当社は一切の責任を負いません。</p>
      <h2>第6条（会員登録）</h2>
      <ol>
        <li>登録希望者は、本規約を遵守することに同意し、かつ、当社の定める一定の情報（以下、「登録情報」といいます。）を当社の定める方法で当社に提供することにより、本サービスの会員登録を申請するものとします。</li>
        <li>前項の申請は、登録希望者自身が行うものとし、真実、正確かつ最新の情報を当社に提供するものとします。</li>
        <li>当社は、本条第1項に基づき会員登録を申請した登録希望者が、以下の各号のいずれかの事由に該当する場合は、当該登録希望者の会員登録を拒否することができるものとします。
          <ul>
            <li>本規約に違反するおそれ又は明確な違反があると当社が判断した場合</li>
            <li>当社に提供された登録情報の全部又は一部につき虚偽、重要な誤記、記載漏れがある場合</li>
            <li>過去に本サービスの会員登録取消処分を受けたことがある場合</li>
            <li>その他当社が会員登録を適当でないと判断した場合</li>
          </ul>
        </li>
        <li>会員は、当社が本サービスを提供するのに必要な範囲において以下に掲げる情報を取得し利用することに同意します。
          <ul>
            <li>登録情報</li>
            <li>本サービスを利用する際に会員が提供した情報</li>
          </ul>
        </li>
        <li>本サービスでは、会員の利便性の向上のために、Googleアカウント、その他第三者が運営するサービス（以下、「外部サービス」といいます。）のアカウントにより会員登録、ログインする機能を提供します。会員が外部サービスのアカウントにより会員登録、ログインする場合、当社が、外部サービスに登録された会員に関する情報を取得する場合があることを会員は承諾するものとします。なお、外部サービスに提供した情報については、外部サービスの利用規約・プライバシーポリシーに従って取り扱われますが、当社が取得した情報については、当社の利用規約・プライバシーポリシーに従って取り扱われます。</li>
      </ol>
      <h2>第7条（サービス利用者の責務）</h2>
      <p>サービス利用者は本サービスを介して、作成したファイルに関する一切の責任を負うものとします。本サービスを介して作成したファイルを利用する際は、内容の信頼性、正確性、完成度、有用性、ウイルスの有無などについて各自で判断し、サービス利用者の責任とリスク負担のもとで利用するものとします。 また、本サービスを介して、以下の行為を行うことを禁止いたします。
      </p>
      <ul>
        <li>他の会員及びサービス利用者または第三者の知的財産権の侵害</li>
        <li>他の会員及びサービス利用者または第三者への誹謗、中傷</li>
        <li>他の会員及びサービス利用者または第三者に不利益を与える行為</li>
        <li>他の会員のID、パスワードを不正に利用する行為</li>
        <li>公序良俗に反する行為</li>
        <li>法令に違反する行為、また、違反のおそれのある行為</li>
        <li>本サービスを通じて配信されたメールの発信元を偽装する行為</li>
        <li>本サービスまたは本サービスを提供する機器もしくはネットワークを妨害したり、混乱させたりする行為</li>
        <li>大量及び大容量のファイルを不特定多数に配布し、当社が提供するインフラ、システム等に多大なる負荷をかける行為</li>
      </ul>
      <h2>第8条（作成したファイルの取り扱い）</h2>
      <ol>
        <li>当社は、本サービスから作成したファイル（以下、「本件作成ファイル」といいます。）に関する一切の責任を負いません。</li>
        <li>本サービスから本件作成ファイルのバックアップはサービス利用者自らが行うものとし、本サービスに保存していたデータが消滅した場合においても、当社はいかなる責任も負いません。</li>
        <li>サービス利用者は、本サービスから本件作成ファイルについて、当社の関知しない種々のネットワークや機器を経由することがあることを理解し、場合によっては、本件作成ファイルの内容に異常をきたす可能性があること、意図しない第三者による盗み見、利用等が行われる可能性がゼロではないことを理解したうえで本サービスを利用するものとします。</li>
      </ol>
      <h2>第9条（本人特定情報の非公開）</h2>
      <p>当社は、会員の個人を特定できる項目の情報（氏名、住所、電話番号、メールアドレスの情報がこれに該当するものとし、以下、「本人特定情報」といいます）を会員の承諾なしに第三者へ公開しないものとします。ただし、下記に該当する場合にはこの限りではありません。</p>
      <ul>
        <li>国の機関もしくは地方公共団体又はその委託を受けた者が法令の定める事務を遂行することに対して協力する必要があり、会員自身の同意を得ることによりその事務の遂行に支障を及ぼす恐れがある場合</li>
        <li>会員自身から第三者への開示又は提供を求められた場合</li>
        <li>その他会員自身へサービスを提供するために必要であると当社が判断した場合</li>
      </ul>
      <h2>第10条（会員登録情報の削除）</h2>
      <p>当社は、以下の事由がある場合には、会員に対し事前に通知することなく会員登録情報の削除を行うことがあります。この場合、当社が会員登録情報を削除し、本サービスの利用ができなくなった場合でも、当社は、サービス利用者に対して一切責任を負わないものとします。</p>
      <ul>
        <li>当社の配信するメールが、登録されたメールアドレスに連続して配信できない場合</li>
        <li>本規約に違反した場合</li>
        <li>登録内容に虚偽事項があったことが判明した場合</li>
        <li>その他、本サービスを利用するのにふさわしくないと当社が判断した場合</li>
      </ul>
      <h2>第11条（サービス利用者からの連絡）</h2>
      <p>本サービスに関してサービス利用者から当社に連絡が必要な場合には、それぞれ該当する窓口あてにメールにて連絡を行うものとします、また、当社は電話・来訪によるご連絡はお受けいたしません。</p>
      <h2>第12条（広告の扱い）</h2>
      <p>サービス利用者は、本サービスに広告が掲載されること及び広告が掲載されたメールが配信されることに同意します。メールを含む本サービスに掲載されている広告や宣伝の内容に関する広告、宣伝の提供者（以下、「広告主」といいます。）とサービス利用者との取引は、サービス利用者と当該広告主の責任において行うものとします。当社は、本サービス中に掲載されている広告によって行われる取引に起因する損害及び広告が掲載されたこと自体に起因する損害については一切の責任を負いません。</p>
      <h2>第13条（サービスに関する無保証）</h2>
      <p>当社は、本サービスの内容、提供の状態、アクセスの可能性、使用の状態について一切の保証をいたしません。問い合わせへの回答など、会員が当社から直接または本サービスを通じて得た情報やアドバイスについても、会員から伝えられた限られた情報に基づいて行われており、その内容の真偽、適格性、正確性について保証するものではありません。</p>
      <h2>第14条（免責事項）</h2>
      <p>当社は、サービス利用者が本サービスを利用したこと、または本サービスを利用できなかったことによって、サービス利用者または第三者に生じた一切の損害について責任を負わないものとします。 これには、直接的、間接的、偶発的、例外的、及び結果的な懲罰的損害（利益、友好関係、効用、データの滅失・毀損・劣化・盗聴・漏洩その他の無形損失を含むがこれに限定されるものではない）などの一切の損害が含まれます。このことは、損害の可能性に関する忠告が事前にあった場合にも適用されます。</p>
      <h2>第15条（国際的利用）</h2>
      <p>本サービスの日本国外での利用は基本的に禁止いたします。技術的な制限ができないため、日本国外においても本サービスの物理的利用は可能かもしれませんが、日本国外に常居所地を有するものは会員登録することができません。本サービスを日本国外で利用したとしても、本規約に基づく利用ではなく、当社の関知しない利用であり、当該利用に関して当社は一切の責任を負わないものとします。</p>
      <h2>第16条（クッキー）</h2>
      <ol>
        <li>本サービスでは、「クッキー（Cookie）」と呼ばれる技術を使用しているページがあります。ウェブページ上に会員のメールアドレスを表示したり、会員専用サービスの利用状況及びアクセス状況を計測し、記録・分析するためにクッキーを利用する場合があります。この場合、当社は上記、計測や記録・分析以外の目的で利用することはありません。</li>
        <li>本ウェブサイト上、または本ウェブサイトを通じて、第三者が提供するサービス(配信広告などのアフィリエイトプログラムやアクセス解析など)にアクセスした場合、当該第三者が掲げるプライバシーポリシーに基づいて、クッキーやウェブビーコンなどによって情報収集の目的で、ご利用者のIPアドレス、訪問日時、ユーザーエージェント、閲覧経路などの情報が自動的に取得・提供されることがあります。</li>
        <li>サービス利用者が、本ウェブサイト及び本ウェブサイトを通じてアクセスした第三者が提供するサービスに、クッキーによって取得される情報を提供することを望まない場合、サービス利用者は、クッキーを無効化することによって情報の提供を拒否することができます。</li>
      </ol>
      <h2>第17条（統計情報、属性情報、利用記録の閲覧、集計及び利用）</h2>
      <p>当社は、会員登録・抹消の前後を問わず、本サービスを利用して会員が登録した会員の登録情報等、本サービスの利用履歴およびこれらを特定の個人を識別または識別しないで解析した後、特定の個人を識別できないように加工、集計および分析した統計データ、属性情報等を作成し、当該解析結果、利用履歴、統計データ、属性情報等につき何らの制限なく利用（求人企業または転職エージェントへ閲覧させること、求人企業または転職エージェントへの提案、市場の調査、新サービスの開発を含みますが、これらに限られません。）することができるものとし、会員はこれをあらかじめ承諾します。</p>
      <h2>第18条（知的財産権）</h2>
      <p>本サービス、及び本ウェブサイト上に掲載される個々の文章、図形、デザイン、商標、ロゴマーク等に関する著作権、商標権その他の知的財産権は、当社に著作権が属しているか、もしくは、当社がその使用許諾を得て提供しているものです。サービス利用者は、著作権、商標権その他の知的財産権を侵害しないことに同意します。</p>
      <h2>第19条（規約の変更）</h2>
      <p>当社は予告なく本規約を変更できるものとします。また本規約が変更され、変更後の規約が本サービスの提供されているウェブページに掲載されたときから直ちに、変更後の内容が適用されます。</p>
      <h2>第20条（本サービスの内容の変更）</h2>
      <p>当社は、いつでも本サービスの内容を変更できるものとし、会員は予めこれを承諾するものとします。</p>
      <h2>第21条（本サービスの利用停止）</h2>
      <p>会員が本サービスの利用を解除する場合は、ウェブページで別途指定する所定の方法にて申し出るものとします 会員が解約した場合、解約と同時に本サービスの利用を終了するものとします。
        <br> 当社は、会員が、本規約に違反した場合、当社が不適切と判断した場合には、事前に告知することなく、本サービスの利用を停止することができます。
      </p>
      <h2>第22条（秘密保持及び会員情報の保護）</h2>
      <p>当社は、会員情報をこの規約で定める場合のほか、別途定めるセキュリティポリシーに基づき、適切に取扱うものとします。但し、次の各号に定める事項については、会員は当社による会員情報の利用及び提供にあらかじめ同意します。</p>
      <ul>
        <li>本サービスを提供するため</li>
        <li>本サービスに付随するサービス提供のため</li>
        <li>メールマガジン、メール広告の送付のため</li>
        <li>アンケートや市場調査のため</li>
        <li>入退会手続き、お問い合わせへの回答のため</li>
      </ul>
      <h2>第23条（準拠法、裁判管轄）</h2>
      <p>本規約の準拠法は日本法とします。また、本サービスまたは本規約に関連して当社と会員の間で生じた紛争については東京地方裁判所を第一審の専属的合意管轄裁判所とします。</p>
      <h2>第24条（協議）</h2>
      <p>本規約に定めていない事項については、信義誠実の原則に従い、協議解決するものとします。</p>
      <p class="text-right">2018年6月28日制定</p>
      <p class="text-right">2021年12月3日改訂</p>
      <div class="back-button">
        <router-link to="/">トップに戻る</router-link>
      </div>
    </div>
  </div>
</div>
</template>
<style lang="scss" src="@/assets/scss/pages/pages.scss"></style>
<script>
export default {
  data: function () {
    return {}
  },
  computed: {},
  methods: {},
  watch: {},
  mounted: function () {}
}
</script>
